module.exports = __webpack_public_path__ + "images/dff6dc2af90896f7b893041ef80d52657772df0e990dc3a05e88e724e2d86f56.svg";